import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ListboxModule } from 'primeng/listbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Shop } from '../../../../shop/types/shop.type';
import { FormsModule } from '@angular/forms';
import { ShopService } from '../../../../shop/service/shop.service';

@Component({
  selector: 'app-custom-shop-selector',
  templateUrl: './custom-shop-selector.component.html',
  styleUrls: ['./custom-shop-selector.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    ListboxModule,
    ProgressSpinnerModule,
    IconFieldModule,
    InputIconModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [TranslateService],
})
export class CustomShopSelectorComponent implements OnInit {
  hasNext = false;
  currentPage = 0;
  loading = true;
  shops: any;
  selectedShop: Shop;
  previousShop: any;
  @Output()
  shopSelected = new EventEmitter<Shop>();
  

  constructor(private readonly shopService: ShopService) {}

  ngOnInit() {
    this.shopService.getPaginatedShops("", 0).subscribe({
      next: (res) => {
        this.shops = res['shops'];
        this.hasNext = res['hasNext'];
        this.loading = false;
      },
    });
  }


   initSelectedAndPreviousShop() {
    this.selectedShop = this.shops[0]
    this.shopSelected.emit(this.selectedShop);
    this.previousShop = this.selectedShop;
    this.loading = false;
  }

  onShopChange(shop): void {
    if (shop != undefined && this.previousShop?.shopCode != shop.shopCode) {
      this.selectedShop = shop;
      this.shopSelected.emit(shop);
      this.previousShop = shop;
    }
  }

  nextPage(): void {
    if (this.hasNext) {
      this.currentPage++;
      this.loadPaginatedShops('', this.currentPage);
    }
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.loadPaginatedShops('', this.currentPage);
    }
  }

  onFilter(event: any): void {
    const value = event.target.value;
    this.loadPaginatedShops(value, this.currentPage);
  }

  loadPaginatedShops(keyword: string, page: number) {
    this.shopService.getPaginatedShops(keyword, page).subscribe({
      next: (res) => {
        this.shops = res['shops'];
        this.hasNext = res['hasNext'];
      },
    });
  }
}
